// Returns which sports are relevant given a sportFocus value.
// Drives field-hiding in ProfilePage so single-sport users don't see
// jargon for sports they don't do.
export const getSportProfile = (sportFocus) => {
  switch (sportFocus) {
    case 'run':       return { swim: false, bike: false, run: true };
    case 'bike':      return { swim: false, bike: true,  run: false };
    case 'swim':      return { swim: true,  bike: false, run: false };
    case 'duathlon':  return { swim: false, bike: true,  run: true  };
    case 'aquabike':  return { swim: true,  bike: true,  run: false };
    case 'triathlon':
    default:          return { swim: true,  bike: true,  run: true  };
  }
};
